import { useCallback, useEffect, useState } from 'react';

const _getElementDimensions = (element?: HTMLElement | null) => {
  if (element == null) return { w: 0, h: 0 };

  const cs = window.getComputedStyle(element);
  const widthStr = cs.getPropertyValue('width').slice(0, -2);
  const heightStr = cs.getPropertyValue('height').slice(0, -2);
  return {
    w: parseInt(widthStr),
    h: parseInt(heightStr),
  };
};

export const useDimensions = (target: React.RefObject<HTMLElement>) => {
  const [dimensions, setDimensions] = useState({ w: 0, h: 0 });

  const handleResize = useCallback(() => {
    const size = _getElementDimensions(target.current);
    if (size.w !== dimensions.w || size.h !== dimensions.h) setDimensions(size);
  }, [target, dimensions]);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return dimensions;
};
